import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/headline_welcome_new.svg")